import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleWare from 'redux-thunk';
import thunk from 'redux-thunk';
import reducers from './reducers';

const defaultState = {};

export default function configureStore(initialState = defaultState) {
    const middleware = [thunk, thunkMiddleWare];
    const enhancers = [
        applyMiddleware(...middleware)
    ];
    
    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose; // eslint-disable-line
    const store = createStore(reducers, initialState, composeEnhancers(...enhancers));
    store.asyncReducers = {};
    return store;
}

